import { render, staticRenderFns } from "./facturadorAdmin.vue?vue&type=template&id=72368c63&scoped=true"
import script from "./facturadorAdmin.vue?vue&type=script&lang=js"
export * from "./facturadorAdmin.vue?vue&type=script&lang=js"
import style0 from "./facturadorAdmin.vue?vue&type=style&index=0&id=72368c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72368c63",
  null
  
)

export default component.exports